
import { Vue, Component, Prop } from 'vue-property-decorator';
import ItemsSummaryMobile from '@/features/shipment/components/ItemsSummaryMobile.vue';
import { PartItem } from '@/features/shipment/types';
import { getPrice } from '@/features/common/helpers';

@Component({
  components: {
    ItemsSummaryMobile,
  },
})
export default class PartsSummaryMobile extends Vue {
  @Prop({ required: true }) parts!: PartItem[];

  @Prop({ required: false, default: false }) showPids!: boolean;

  // eslint-disable-next-line class-methods-use-this
  private hasPids(item: PartItem): boolean {
    return !!(item.merchantProductId
      || item.manufacturerProductId
      || item.standardProductId);
  }

  private getPartDetailsInPlainText(item: PartItem): string {
    const {
      quantity,
      quantityUnits,
      detailedDescription,
      countryOfOrigin,
      hsCode,
      unitValue,
    } = item;

    const quantityLabel = `${quantity} ${quantityUnits}`;

    const unitValueLabel = `${this.$t('labels.unitValue')}: ${getPrice(+unitValue, 2)}`;

    const totalPrice = `${this.$t('tables.total')}: ${getPrice(quantity * unitValue)}`;

    const values = [
      quantityLabel,
      countryOfOrigin,
      unitValueLabel,
      totalPrice,
    ];

    let output = values.filter(Boolean).join(', ');

    if (detailedDescription) {
      output += `<br />${detailedDescription}`;
    }

    if (hsCode) {
      output += `<br />${this.$t('labels.hsCode')}: ${hsCode}`;
    }

    return output;
  }
}
